import { apiFetch } from '../../../../common/api/apiFetchClient';

const BASE = '/api/rfi/file';

export interface BatchRunHistoryItem {
  batchId: number;
  fileName: string | null;
  totalRecords: number;
  error: string | null;
  processedDate: string | null;
  jobType: 'read' | 'push';
  source: 'manual' | 'scheduled';
  status: 'success' | 'failed';
}

export const batchJobsApi = {
  getRecentJobRuns(): Promise<BatchRunHistoryItem[]> {
    return apiFetch(`${BASE}/history`, {
      method: 'GET',
    });
  },

  triggerReadUdwDataFromNasDrive(): Promise<string> {
    return apiFetch(`${BASE}/readUDWDataFromNASDrive`, {
      method: 'POST',
    });
  },

  triggerPushRfiDataToNasDrive(): Promise<string> {
    return apiFetch(`${BASE}/pushRFIDataToNASDrive`, {
      method: 'POST',
    });
  },
};